// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"516":"question","857":"document"}[chunkId] + "." + {"516":"82e6f98c","857":"ebff13b5"}[chunkId] + ".css";
};